import { FC } from "react";
import { Button } from "@chakra-ui/react";

interface Props {
  children?: string;
}

export const EmailLink: FC<Props> = ({ children }) => {
  return (
    <Button
      as="a"
      h="unset"
      href={`mailto:${children}`}
      fontSize="18px"
      px={0}
      pb="5px"
      variant="th-text-link"
    >
      {children}
    </Button>
  );
};
